import stripAnsi from 'strip-ansi';

import { Widget } from '@@/Widget';

interface LogBoxProps {
  logs: string;
  maxLines?: number;
}

export function LogBox({ logs, maxLines = 20 }: LogBoxProps) {
  const logLines = logs.replace(/\n+$/, '').split('\n');
  const displayedLogs = logLines.slice(-maxLines);

  const emptyLines = Math.max(0, maxLines - displayedLogs.length);
  const emptyEntries = Array(emptyLines).fill(null);
  const allLogs = [...displayedLogs, ...emptyEntries];

  const joinedLogs = allLogs.join('\n');

  return (
    <Widget className="bg-gray-2 p-3 th-dark:bg-gray-iron-10 th-highcontrast:bg-transparent th-highcontrast:border th-highcontrast:border-white">
      <div className="whitespace-pre-wrap space-y-3 font-mono text-xs break-words  th-dark:text-gray-iron-5 th-highcontrast:text-white">
        {displayedLogs.length === 0
          ? 'No logs available...'
          : cleanLog(joinedLogs)}
      </div>
    </Widget>
  );
}

function cleanLog(raw: string): string {
  return stripAnsi(raw).replace(/[^\n\t\r\x20-\u007E\u00A0-\uFFFF]/g, '');
}
